import React from "react";
import { useTokenContext } from "../../auth/UserTokenProvider";
import { CurrentlyPlayingState, PlayingStates } from "../../types/currentlyPlayingState";
import { ITrackLyrics } from "../../types/trackLyrics";
import Advertisement from "./Advertisement";
import Error from "./Error";
import Loading from "./Loading";
import NoTrackPlaying from "./NoTrackPlaying";
import TrackPlaying from "./TrackPlaying";
import Welcome from "./Welcome";

interface IProps {
  user: SpotifyApi.UserObjectPrivate | null;
  userLoading: boolean;
  currentlyPlayingSong: CurrentlyPlayingState;
  lyrics: ITrackLyrics | undefined;
}

const LyricsView: React.FunctionComponent<IProps> = ({
  user,
  userLoading,
  currentlyPlayingSong,
  lyrics
}) => {
  const { isLoading } = useTokenContext();

  // Show loading while checking for existing session (prevents login screen flash)
  if (isLoading || (userLoading && user === null)) {
    return <Loading />;
  }

  if (user === null) {
    return <Welcome />;
  } else if (currentlyPlayingSong.state === PlayingStates.Loading) {
    return <Loading />;
  } else if (currentlyPlayingSong.state === PlayingStates.NotPlaying) {
    return <NoTrackPlaying />;
  } else if (currentlyPlayingSong.state === PlayingStates.Error) {
    return <Error />;
  } else if (currentlyPlayingSong.currentlyPlayingObject.currently_playing_type === "ad") {
    return <Advertisement />;
  } else {
    return <TrackPlaying lyricDetails={lyrics} currentlyPlayingSong={currentlyPlayingSong} />;
  }
};

export default LyricsView;
